import * as attemptSurveyActions from "./attemptSurvey.actions";

export const attemptSurveyFeatureKey = "attemptSurveyInfo";

const initialState = {
  startSurveyData: {},
  isLoading: false,
  error: null,
  surveyQuestions: [],
  isLastQuestion: null,
  submitSurveyAnswer: null,
  submitPreliminarySurveyAnswer: null,
  updateUserProfile: null,
  preliminarySurvey: null,
  submitCaracteristicsSurveyAnswer: null,
  preliminarySurveyResults: null,
  getUserSurveyAnswer: null,
  sameSurveyAnswer: null,
};

export const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case attemptSurveyActions.START_SURVEY_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case attemptSurveyActions.START_SURVEY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        startSurveyData: payload,
      };
    case attemptSurveyActions.START_SURVEY_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    case attemptSurveyActions.START_SURVEY_RESET:
      return {
        ...state,
        isLoading: false,
        error: null,
        startSurveyData: null,
      };
    case attemptSurveyActions.GET_SURVEY_QUESTIONS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        surveyQuestions: [],
      };
    case attemptSurveyActions.GET_SURVEY_QUESTIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        surveyQuestions: payload,
      };
    case attemptSurveyActions.GET_SURVEY_QUESTIONS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload,
        surveyQuestions: [],      
      };
    case attemptSurveyActions.GET_SURVEY_QUESTIONS_RESET:
      return {
        ...state,
        isLoading: false,
        error: null,
        surveyQuestions: [],
      };
    case attemptSurveyActions.IS_LAST_QUESTION_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case attemptSurveyActions.IS_LAST_QUESTION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        isLastQuestion: payload,
      };
    case attemptSurveyActions.IS_LAST_QUESTION_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    case attemptSurveyActions.SUBMIT_SURVEY_ANSWER_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case attemptSurveyActions.SUBMIT_SURVEY_ANSWER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        submitSurveyAnswer: payload,
      };
    case attemptSurveyActions.SUBMIT_SURVEY_ANSWER_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    case attemptSurveyActions.RESET_PASSWORD_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case attemptSurveyActions.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    case attemptSurveyActions.RESET_PASSWORD_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    case attemptSurveyActions.UPDATE_USER_PROFILE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case attemptSurveyActions.UPDATE_USER_PROFILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        updateUserProfile: payload,
      };
    case attemptSurveyActions.UPDATE_USER_PROFILE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };  
    case attemptSurveyActions.IS_USER_PARTICIPATED_IN_SURVEY_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case attemptSurveyActions.IS_USER_PARTICIPATED_IN_SURVEY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        isUserParticipatedInSurvey: payload,
      };
    case attemptSurveyActions.IS_USER_PARTICIPATED_IN_SURVEY_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    case attemptSurveyActions.IS_USER_PARTICIPATED_IN_SURVEY_RESET:
      return {
        ...state,
        isLoading: false,
        error: null,
        isUserParticipatedInSurvey: null,
      };
    case attemptSurveyActions.GET_PRELIMINARY_SURVEY_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case attemptSurveyActions.GET_PRELIMINARY_SURVEY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        preliminarySurvey: payload,
      };
    case attemptSurveyActions.GET_PRELIMINARY_SURVEY_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    case attemptSurveyActions.SUBMIT_PRELIMINARY_SURVEY_ANSWER_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };  
    case attemptSurveyActions.SUBMIT_PRELIMINARY_SURVEY_ANSWER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        submitPreliminarySurveyAnswer: payload,
      };
    case attemptSurveyActions.SUBMIT_PRELIMINARY_SURVEY_ANSWER_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };

    case attemptSurveyActions.SUBMIT_CARACTERISTICS_SURVEY_ANSWER_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case attemptSurveyActions.SUBMIT_CARACTERISTICS_SURVEY_ANSWER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        submitCaracteristicsSurveyAnswer: payload,
      };
    case attemptSurveyActions.SUBMIT_CARACTERISTICS_SURVEY_ANSWER_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    case attemptSurveyActions.GET_PRELIMINARY_SURVEY_RESULTS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case attemptSurveyActions.GET_PRELIMINARY_SURVEY_RESULTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        preliminarySurveyResults: payload,
      };
    case attemptSurveyActions.GET_PRELIMINARY_SURVEY_RESULTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    case attemptSurveyActions.RESET_PASSWORD_USING_PHONE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };    
    case attemptSurveyActions.RESET_PASSWORD_USING_PHONE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    case attemptSurveyActions.RESET_PASSWORD_USING_PHONE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    case attemptSurveyActions.GET_USER_SURVEY_ANSWER_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case attemptSurveyActions.GET_USER_SURVEY_ANSWER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        getUserSurveyAnswer: {
          ...state.getUserSurveyAnswer,
          ...payload,
        },
      };
    case attemptSurveyActions.GET_USER_SURVEY_ANSWER_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };

    case attemptSurveyActions.GET_SAME_SURVEY_ANSWER_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };  
    case attemptSurveyActions.GET_SAME_SURVEY_ANSWER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        sameSurveyAnswer: payload,
      };
    case attemptSurveyActions.GET_SAME_SURVEY_ANSWER_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
      default:
      return state;
  }
};

export default reducer;
